<template>
  <div class="alarmTableCom">
    <el-table ref="drawTable" :data="tableData" height="99%" stripe size="mini" :row-key="getRowKeys"
      @cell-click="cellClick" :cell-style="cellStyle" @selection-change="handleSelectionChange" :header-cell-style="{
          'background-color': '#F7F7F7',
        }">
      <el-table-column type="selection" width="50" align="center" reserve-selection v-if="showCheckbox"
        :selectable="selectable">
      </el-table-column>
      <el-table-column v-for="(v, i) in tabHead" :key="i" :prop="v.prop" :label="v.label" align="center" :width="v.prop=='handleState' || v.prop=='alarmSeverity'?'80':''">
        <template slot-scope="scope">
          <span v-if="scope.row[v.prop] && v.prop !== 'alarmEndTime' && scope.row[v.prop].length >= 10">
            <el-tooltip class="item" effect="dark" :content="scope.row[v.prop]" placement="top-start">
              <div>{{ scope.row[v.prop] }}</div>
            </el-tooltip>
          </span>
          <span v-else>{{ scope.row[v.prop] }}</span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" align="center" width="130">
        <template slot-scope="scope">
          <el-button v-if="scope.row.toWOrkOrder" @click="handleClick(scope.row)" type="text" size="mini">已转工单</el-button>
          <el-button type="text" size="mini"
            v-if="!scope.row.toWOrkOrder && judgeAuthority('shebei:alarmManagement:edit')"
            @click="workOrder(scope.row)">转工单</el-button>
          <el-button type="text" size="mini" @click="showDrawer(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <SubmitWorkOrder v-if="dialogVisible" :activeItem="activeItem" />
    <el-drawer :visible.sync="drawerState" v-if="showDetails" title="报警详情" class="drawerWrap" size="30%"
      :before-close="handleClose">
      <DetailsDrawer :activeItem="activeItem" />
    </el-drawer>

  </div>
</template>

<script>
import api from "@/api";
import SubmitWorkOrder from "@/components/shebeiguanli/baojingguanli/SubmitWorkOrder";
import DetailsDrawer from "@/components/shebeiguanli/baojingguanli/DetailsDrawer";
import { matchingAlarmColor, judgeAuthority } from "@/assets/js/utils";
export default {
  props: {
    tabHead: {
      type: Array,
      default: () => []
    },
    tableData: {
      type: Array,
      default: () => []
    },
    showCheckbox: {
      type: Boolean,
      default: false
    },
    selectableAlways: {
      type: Boolean,
      default: false
    },
  },
  components: {
    SubmitWorkOrder,
    DetailsDrawer,
  },
  data() {
    return {
      choiceID: [],
      activeItem: {},
      dialogVisible: false,
      showDetails: false,
      drawerState: false,
      multipleSelection: [],
    };
  },
  methods: {
    judgeAuthority,
    cellStyle(row) {
      if (row.column.label === "报警级别") {
        return matchingAlarmColor(row.row.alarmSeverity);
      }
      if (row.column.label === "确认状态") {
        if (!row.row.confirm) {
          return "color:#28CCCB;cursor: pointer";
        }
      }
    },
    cellClick(row, column) {
      if (column.label === "确认状态" && !row.confirm) {
        this.choiceID = [row.alarmId];
        this.handleConfirm();
      }
    },
    batchProcessing() {
      if (this.multipleSelection.length == 0) {
        this.$message.error("未选择列表!");
        return;
      }
      this.choiceID = this.multipleSelection.map((item) => {
        return item.alarmId;
      });
      this.handleConfirm();
    },
    handleConfirm() {
      this.$confirm(
        `此操作将${this.choiceID.length > 1 ? "批量确认" : "确认"
        }状态, 是否继续?`,
        `${this.choiceID.length > 1 ? "批量确认" : "确认"}`,
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          let res = await api.getSAlarmhandleConfirm({
            ids: this.choiceID.join(","),
          });
          if (res && res.data.code == 200) {
            this.$message.success("操作成功!");
            this.resetSelection();
            this.$store.commit("SET_LOADING", true);
            setTimeout(() => {
              this.$parent.getAlarmsList();
            }, 500);
          }
        })
        .catch(() => { });
    },
    resetSelection() {
      this.multipleSelection = [];
      this.$refs.drawTable.clearSelection();
    },
    getRowKeys(row) {
      return row.alarmId;
    },
    selectable(row) {
      return this.selectableAlways || !row.confirm;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleClick(row) {
      this.$router.push({
        path: "/worksheets",
        query: { id: row.workOrderId },
      });
    },
    workOrder(row) {
      this.activeItem = row;
      this.choiceID = [row.alarmId];
      this.confirmStatus();
      this.dialogVisible = true;
    },
    showDrawer(row) {
      this.activeItem = row;
      this.choiceID = [row.alarmId];
      this.confirmStatus();
      this.showDetails = true;
      this.$nextTick(() => {
        this.drawerState = true;
      });
    },
    getAlarmsList() {
      this.$parent.getAlarmsList();
    },
    handleClose() {
      this.showDetails = false;
      this.drawerState = false;
    },
    async confirmStatus() {
      await api.getSAlarmhandleConfirm({
        ids: this.choiceID.join(","),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.alarmTableCom {
  width: 100%;
  height: 100%;

  ::v-deep .cell {
    .el-tooltip {
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      word-break: break-all;
    }
  }
}
</style>